import React from 'react';
import {Logo, Typography} from '@customink/pigment-react';
import services from '../../api/remoteServices';

const OrderConfirmationHeader: React.FC = () => {
  return (
    <div className="orderConfirmation-body-header">
      <a href={services.homePage} rel="noopener noreferrer" target="_blank">
        <Logo
          variant="inky"
          onClick={() => {
            /* do nothing */
          }}
          className="app-logo"
          placeholder="inky logo"
        />
      </a>
      <div className="placedDate">
        <Typography className="title">Order Placed</Typography>
        <Typography variant="h6">August 25, 2022</Typography>
        {/* [TODO: Where will the above date come from?] */}
      </div>
    </div>
  );
};

export default OrderConfirmationHeader;
